module.exports = __webpack_public_path__ + "img/temp-calendar.c9379cc8.png";